import { render, staticRenderFns } from "./TotalCategoriesCount.vue?vue&type=template&id=43663142&scoped=true&"
import script from "./TotalCategoriesCount.vue?vue&type=script&lang=js&"
export * from "./TotalCategoriesCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43663142",
  null
  
)

export default component.exports